import { render, staticRenderFns } from "./generalRewards.vue?vue&type=template&id=c321f88c&scoped=true&"
import script from "./generalRewards.vue?vue&type=script&lang=js&"
export * from "./generalRewards.vue?vue&type=script&lang=js&"
import style0 from "./generalRewards.vue?vue&type=style&index=0&id=c321f88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321f88c",
  null
  
)

component.options.__file = "generalRewards.vue"
export default component.exports